function customerCare() {
	var customerCareForm = $("#send-question-form");
	var formSubmitButton = $("#contact-us-submit");
	var formEmailField = $("#contact-us-email");

	var showConfirmation = function () {
		var confirmationMsg = $("<h1>Your message has been sent</h1>");
		$(confirmationMsg).attr("class", "footer__title");
		customerCareForm.parent().append(confirmationMsg);
		customerCareForm.remove();
	};

	var showError = function () {
		var errorMsg = $(
			"<h1>Message could not be sent. Please try again later.</h1>"
		);
		$(errorMsg).attr("class", "footer__title");
		$(errorMsg).css("color", "red");
		customerCareForm.parent().append(errorMsg);
	};

	var isFormCorrect = function () {
		return (
			formEmailField.hasClass("correct") &&
			isQuestionValid($("#contact-us-textarea").val())
		);
	};

	var isQuestionValid = function (question) {
		return question.length > 0 && question.length <= 3000;
	};

	formSubmitButton.on("click", function (e) {
		e.preventDefault();
		if (isFormCorrect()) {
			if (isStageEnv) {
				$("#send-question-form-captcha").closest("form").submit();
			} else {
			sendQuestion(e);
			}
		}
	});

	customerCareForm.on("submit", function (e) {
		e.preventDefault();

		if (isFormCorrect()) {
			formSubmitButton.prop("disabled", true);
			var formData = customerCareForm.serialize();
			$.ajax({
				url: apiPath + "questions",
				type: "POST",
				data: formData,
				success: function (data) {
					if (data.message == "success") {
						customerCareForm[0].reset();
						showConfirmation();
					} else {
						showError();
					}
				},
				error: function () {
					showError();
				},
			});
		}
		return false;
	});
}
